/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getConfiguration } from '../fn/configuration/get-configuration';
import { GetConfiguration$Params } from '../fn/configuration/get-configuration';
import { ShConfiguration } from '../models/sh-configuration';

@Injectable({ providedIn: 'root' })
export class ConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConfiguration()` */
  static readonly GetConfigurationPath = '/rest/configuration';

  /**
   * Get configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfiguration$Response(params?: GetConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ShConfiguration>> {
    return getConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Get configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfiguration(params?: GetConfiguration$Params, context?: HttpContext): Observable<ShConfiguration> {
    return this.getConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShConfiguration>): ShConfiguration => r.body)
    );
  }

}
